
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	
	import {
		rolelist,
		roleDelete
	} from '@/api/auth';
	
	import PageFooter from '@/components/page-footer.vue';
	import EditRoleDialog from './components/edit-role-dialog.vue';

	@Component({
		name: 'auth-roles',
		components: {
			PageFooter,
			EditRoleDialog,
		}
	})
	export default class AuthRoles extends Vue {

		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private list: any = [];
		private roleId = 0;
		
		//添加角色
		private showDialog = false;

		private rowmsg:any = {}
		private showJianXi = false
		
		private mounted(){
			this.getList();
		}
		


		// 创建角色
		private toCreate(){
			this.roleId = 0;
			this.showDialog = true;
		}
		
		// 分页
		private changePage(e:any) {
			this.pageNo = e;
			this.getList();
		}
		
		//获取角色列表
		private async getList(){
			try{
				const res:any = await rolelist({
					Skip: (this.pageNo-1)*this.pageSize,
					Take: this.pageSize
				})
				this.total = res.Result.Total;
				this.list = res.Result.Results;
			}catch(err){
			}
		}
		
		//编辑
		private handleEdit(record:any){
			this.roleId = record.Id;
			this.showDialog = true;
		}
		
		//删除
		private async handleDelete(record:any){
			
			if (record.EmployeeCount){
				this.$message.error('角色下存在员工，不允许删除');
				return;
			}
				
			try{
				const res:any = await roleDelete({
					Id: record.Id
				})
				this.$message.success('删除成功');
				this.getList();
			}catch(err){
				
			}
		}
	}
